const unary = (fn) => (val) => fn(val);

export default unary;
